import gql from 'graphql-tag';

export const updateAiringMutation = gql`
	mutation updateAiring($airing: AiringInput!, $gameId: ID!) {
		updateAiring(airing: $airing, gameId: $gameId) {
			businessLogic
			channelId
			id
			status
			startTime
			offsets {
				items {
					segment
					offset
				}
			}
			clientExclusions
			exclusionPlayIds
			programSynopsis
			programStartTime
			programEndTime
		}
	}
`;

export const deleteAlternateId = gql`
	mutation deleteAlternateId($id: ID!) {
		deleteAlternateId(id: $id) {
			id
		}
	}
`;

export const createAlternateId = gql`
	mutation createAlternateId($alternateId: AlternateIdInput!) {
		createAlternateId(alternateId: $alternateId) {
			id
			alternateId
			namespace
		}
	}
`;
